import EditClientTypeForm from './EditClientTypeForm';

export default EditClientTypeForm;
